(function(scope){
 'use strict';
 const marker='_bellzi_promotion';
 const isGift=item=>Boolean(item.properties?.[marker]);
 function eligible(cart,rule,now=Date.now()){
  if(!rule.enabled||!rule.verified||cart.currency!==rule.currency||!rule.variantId||!(rule.minimum>0))return false;
  const start=rule.startsAt?Date.parse(rule.startsAt):null,end=rule.endsAt?Date.parse(rule.endsAt):null;
  if((rule.startsAt&&!Number.isFinite(start))||(rule.endsAt&&!Number.isFinite(end)))return false;
  if((start!==null&&now<start)||(end!==null&&now>=end)||(start!==null&&end!==null&&end<=start))return false;
  const excluded=new Set((rule.excludedProductIds||[]).map(String));
  const qualifying=cart.items.filter(i=>!isGift(i)&&!i.gift_card&&!i.selling_plan_allocation&&String(i.variant_id)!==String(rule.variantId)&&!excluded.has(String(i.product_id)));
  const amount=qualifying.reduce((sum,i)=>sum+Number(i.final_line_price||0),0);
  return amount>=rule.minimum;
 }
 function plan(cart,rules,{now=Date.now(),dismissed=new Set(),unavailable=new Set()}={}){
  const active=rules.filter(r=>eligible(cart,r,now)&&!dismissed.has(r.id)&&!unavailable.has(r.id));
  const chosen=active.sort((a,b)=>b.minimum-a.minimum)[0];
  const gifts=cart.items.filter(isGift),updates={},keep=[];
  for(const item of gifts){
   if(!chosen||item.properties[marker]!==chosen.id||String(item.variant_id)!==String(chosen.variantId)||Number(item.final_line_price)!==0||keep.length){updates[item.key]=0;}
   else {keep.push(item);if(item.quantity!==1)updates[item.key]=1;}
  }
  const paidSame=chosen&&cart.items.some(i=>!isGift(i)&&String(i.variant_id)===String(chosen.variantId));
  return {updates,add:chosen&&!keep.length&&!paidSame?{id:chosen.variantId,quantity:1,properties:{[marker]:chosen.id}}:null,rule:chosen||null};
 }
 const api={marker,isGift,eligible,plan};scope.BellziGiftCore=api;
 if(typeof module!=='undefined'&&module.exports)module.exports=api;
})(typeof window!=='undefined'?window:globalThis);

